/**
 * Application Entry Point
 * 
 * This file serves as the main entry point for the React application.
 * It renders the root App component into the DOM and wraps it with React's StrictMode
 * for enhanced development experience and error checking.
 */

import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Get the root element and ensure it exists
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found. Make sure the HTML template includes a div with id="root"');
}

// Create React root and render the application
const root = createRoot(container);

root.render(

    <App />
);
